export function initAutoplayVideo() {
  const videos = document.querySelectorAll(".js-autoplay-video");

  if (!videos.length) return;

  videos.forEach(video => {
    const threshold = parseFloat(video.dataset.threshold) || 0.5;
    const shouldLoop = video.dataset.loop === "true";

    if (shouldLoop) {
      video.addEventListener("ended", () => {
        video.currentTime = 0;
        video.play();
      });
    }

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          video.play();
        } else {
          video.pause();
        }
      });
    }, { threshold });

    observer.observe(video);
  });
}
